import type { RouterConfig } from '@nuxt/schema';
import type { RouteLocationNormalized } from 'vue-router';

export default <RouterConfig>{
    scrollBehavior: (to, from, savedPosition) => {
        if (from.hash.includes('MrP') && !to.hash.includes('MrP')) {
            return false;
        }
        const nuxtApp = useNuxtApp();
        let position: any = savedPosition;
        if (
            !position &&
            from &&
            to &&
            to.meta.scrollToTop !== false &&
            _isDifferentRoute(from, to)
        ) {
            position = { left: 0, top: 0 };
        }
        if (to.path === from.path) {
            if (from.hash && !to.hash) {
                return { left: 0, top: 0 };
            }
            if (to.hash) {
                return {
                    el: to.hash,
                    top: _getHashElementScrollMarginTop(to.hash),
                };
            }
        }
        const hasTransition = (route: RouteLocationNormalized) =>
            !!(route.meta.pageTransition ?? false);
        const hookToWait =
            hasTransition(from) && hasTransition(to)
                ? 'page:transition:finish'
                : 'page:finish';
        return new Promise(resolve => {
            nuxtApp.hooks.hookOnce(hookToWait, async () => {
                await nextTick();
                if (to.hash) {
                    position = {
                        el: to.hash,
                        top: _getHashElementScrollMarginTop(to.hash),
                    };
                }
                resolve(position);
            });
        });
    },
};

function _getHashElementScrollMarginTop(selector: string) {
    try {
        const elem = document.querySelector(selector);
        if (elem) {
            return parseFloat(getComputedStyle(elem).scrollMarginTop);
        }
    } catch {}
    return 0;
}
function _isDifferentRoute(
    a: RouteLocationNormalized,
    b: RouteLocationNormalized
) {
    const samePageComponent = a.matched[0] === b.matched[0];
    if (!samePageComponent) {
        return true;
    }
    return (
        samePageComponent &&
        JSON.stringify(a.params) !== JSON.stringify(b.params)
    );
}
